export const completeTargetURL = (targetURL: string): string => {
  const { href } = document.location;
  const hasLayerHash = targetURL.includes('#oneLayer=/');
  return targetURL.startsWith('/') || hasLayerHash ? `${href}${targetURL}` : targetURL;
};
